import type { ScaleLinear } from 'd3-scale';

const barMargin = 6;
const barWidth = 12;

export const gaugeRadius = 120;
export const max: number = 0.5 * Math.PI;
export const stop: number = 0.5 * Math.PI;
export const stopOverflow: number = 0.56 * Math.PI;

export const getRingRadius = (position: string, level = 0): number => {
  if (position === 'outer') {
    return gaugeRadius - barWidth * level - (level > 0 ? barMargin * level : 0);
  }
  return gaugeRadius - barWidth * level - barMargin * level - barWidth;
};

export const getEndAngle = (
  xScale: ScaleLinear<number, number>,
  value: number
): number => {
  const max = xScale.invert(stop);
  const min = xScale.invert(-stop);
  if (value > max) {
    return stopOverflow;
  } else if (value < min) {
    return -stopOverflow;
  }
  return xScale(value) || 0;
};

export const getXYCoord = (radius, theta) => ({
  x: radius * Math.sin(theta),
  y: -radius * Math.cos(theta),
});
